// extracted by mini-css-extract-plugin
export default {"toggle-confirmation-wrapper":"ToggleModalConfirmation_toggle-confirmation-wrapper__Sg6Ms"};